import { useAtomValue } from 'jotai';
import { queryClientAtom } from 'jotai-tanstack-query';
import { useCallback } from 'react';
import {
  buildPlayerDataLockerMetricDistributionQueryOptions,
  normalisedToRawMetricKeys,
} from '@/atoms/dataLocker/metrics';
import { fetchClientAtom } from '@/atoms/queries/client';
import { unwrappedMetricLookupMapAtom } from '@/atoms/queries/metric';
import { unwrappedGenderAtom } from '@/atoms/queries/userConfigs';

// Warms the TanStack Query cache as the user toggles metrics, so data is ready when they hit Apply
export const usePrefetchPlayerMetricDistributions = () => {
  // queryClientAtom rather than useQueryClient() — app has no QueryClientProvider, client lives in Jotai
  const queryClient = useAtomValue(queryClientAtom);
  const { fetch } = useAtomValue(fetchClientAtom);
  const gender = useAtomValue(unwrappedGenderAtom);
  const metricLookupMap = useAtomValue(unwrappedMetricLookupMapAtom);

  return useCallback(
    (normalisedMetricNames: string[]) => {
      const rawMetricKeys = normalisedToRawMetricKeys(normalisedMetricNames, metricLookupMap);
      if (!rawMetricKeys.length || !gender) return;
      const { queryKey, queryFn } = buildPlayerDataLockerMetricDistributionQueryOptions(gender, rawMetricKeys, fetch);
      queryClient.prefetchQuery({ queryKey, queryFn });
    },
    [queryClient, fetch, gender, metricLookupMap],
  );
};
